export default {
    goods_name: 'Ticket Name',
    goods_status: 'Ticket Status',
    goods_type: 'Ticket Category',
    goods_money: 'Amount',
    creator: 'Creator',
    add_goods: 'Add Ticket',
    goods_number: 'Ticket Number',
    inventory: 'Inventory',
    sales_volume: 'Sales Volume',
    creation_time: 'Creation Time',
    shelf_time: 'Shelf Time',
    put_away: 'Put Away',
    sold_out: 'Sold Out',
    distribution: 'Distribution',
    unlimited: 'Unlimited',
    limited_inventory: 'Limited Inventory',
    goods_information: 'Ticket Information',
    basic_price: 'Basic Price',
    remaining_inventory: 'Remaining Inventory',
    goods_brief: 'Ticket Brief',
    distribution_information: 'Distribution Information',
    piece: 'Piece',
    sub_forum_name: 'Sub Forum Name',
    forum_status: 'Forum Status',
    deadline: 'Deadline',
    distribution_total_not_greater_than_inventory: 'Total distribution cannot be greater than inventory',
    distribution_volume: 'Distribution Volume',
    is_sale: 'Is Saleable',
    ended: 'Ended',
    in_progress: 'In Progress',
    distribution_total_not_greater_than_remaining_inventory: 'Total distribution cannot be greater than remaining inventory',
    basic_information: 'Basic Information',
    detailed_description: 'Detailed Description',
    sales_information: 'Sales Information',
    goods_id: 'Ticket ID',
    goods_preview: 'Ticket Preview Image',
    brief_content: 'Brief Content',
    sales_period: 'Sales Period',
    is_limited: 'Is Limited Purchase',
    inventory_total: 'Total Inventory',
    per_capita_limit: 'Per Capita Ticket Limit',
    unlimited_purchase: 'Unlimited Purchase',
    shelf_information: 'Shelf Information',
    not_on_the_shelf: 'Not on Shelf',
    immediate_shelf: 'Immediate Shelf',
    you_can_only_upload_image_files: 'You can only upload image files',
    status: 'Status',
    edit_price: 'Edit Price',
    currency: 'Currency',
    showSurplus: 'Show Remaining Quantity',
    showPrice: 'Show Amount',
    min_num: 'Min Purchase Quantity',
    max_num: 'Max Purchase Quantity',
    show_status: 'Ticket Visibility Settings',
    show_status0: 'Hide All',
    show_status1: 'Visible to All Channels',
    show_status2: 'Visible in User Center',
    show_status3: 'Visible to Independent Channel',
    unit: 'Unit',
    not_delete: 'Tickets on the shelf cannot be deleted'
};
